import { useMutation } from '@tanstack/react-query';
import { register } from '@/api/auth';
import { applyAuthResult } from './auth-session';

/**
 * `POST /api/auth/register` como mutación (TanStack Query).
 *
 * El endpoint crea el usuario Y su primer tenant (el usuario queda como ADMIN de ese
 * negocio), así que la respuesta es idéntica a la del login y se aplica igual: no hace falta
 * un paso extra de "iniciar sesión después de registrarse".
 *
 * Errores esperables: 409 si el email ya tiene cuenta, 400 si el body no pasa la validación.
 */
export function useRegister() {
  return useMutation({
    mutationFn: register,
    onSuccess: applyAuthResult,
  });
}
